import {
  Flex,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Spinner,
  Stack,
  Text,
  Box,
} from '@chakra-ui/react';
import { CloseCircleOutline, DEFAULT_DATE_FORMAT } from '@aslanpay/portal-common-lib';

import { Table } from 'app/components/UI/Table/Table';

import getGiftedEmployeesColumns from 'app/utils/table/gifting/giftedEmployees';

import { format, parseISO } from 'date-fns';
import formatNumber from 'app/utils/formatting';

import { BulkGiftingDetailsModalProps } from './types';

function BulkGiftingDetailsModal({
  isOpen,
  onClose,
  showRewardDetails,
  employees,
  rewardDetails,
  isLoadingEmployeesData,
  totalEmployees,
  pagination,
  onPaginationChange,
}: BulkGiftingDetailsModalProps) {
  const handleClose = () => {
    onClose();
  };

  const PAGE_SIZE_OPTIONS = [
    { value: 15, text: '15 rows / page' },
    { value: 25, text: '25 rows / page' },
    { value: 50, text: '50 rows / page' },
  ];

  return (
    <Modal isOpen={isOpen} closeOnEsc={false} closeOnOverlayClick={false} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent minWidth="fit-content">
        <ModalHeader>
          <HStack>
            <Text as="h6">Rewarding details</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close reward points"
              onClick={handleClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody mt="20px">
          <Stack>
            {showRewardDetails && rewardDetails && (
              <Box mb="20px">
                <HStack
                  borderRadius="5px"
                  bg="brand.mutedPurple"
                  py="12px"
                  px="20px"
                  justifyContent="space-between"
                  mb="20px"
                >
                  <Box>
                    <Text textStyle="extraSmallSemiBold" color="brand.white" mb="3px">
                      Date
                    </Text>
                    <Text textStyle="h6SemiBold" color="brand.white">
                      {format(parseISO(rewardDetails.rawDate), DEFAULT_DATE_FORMAT)}
                    </Text>
                  </Box>
                  <Box>
                    <Text textStyle="extraSmallSemiBold" color="brand.white" mb="3px">
                      No. of points awarded
                    </Text>
                    <Text textStyle="h6SemiBold" color="brand.white">
                      {formatNumber(rewardDetails.points)}
                    </Text>
                  </Box>
                  <Box>
                    <Text textStyle="extraSmallSemiBold" color="brand.white" mb="3px">
                      Reason
                    </Text>
                    <Text textStyle="h6SemiBold" color="brand.white">
                      {rewardDetails.reason}
                    </Text>
                  </Box>
                </HStack>
                <Text mb="6px" textStyle="smallRegular" color="brand.darkGray">
                  Notification Reason
                </Text>
                <Text textStyle="smallMedium" color="brand.mutedpurple">
                  {rewardDetails.reasonText}
                </Text>
              </Box>
            )}

            <Flex alignItems="center" direction="column">
              {!employees.length ? (
                <Spinner data-testid="spinner-table" />
              ) : (
                <>
                  <Flex
                    width="100%"
                    justifyContent="end"
                    textAlign="end"
                    mb="6px"
                    mt="0px !important"
                  >
                    <Text textStyle="smallMedium" color="brand.darkGray">
                      Showing {pagination.pageIndex * pagination.pageSize + 1}–
                      {Math.min((pagination.pageIndex + 1) * pagination.pageSize, totalEmployees)}{' '}
                      of {totalEmployees} results
                    </Text>
                  </Flex>
                  {isLoadingEmployeesData ? (
                    <Spinner data-testid="spinner-table" />
                  ) : (
                    <Table
                      columns={getGiftedEmployeesColumns()}
                      data={employees}
                      total={totalEmployees}
                      pageNumber={pagination.pageIndex}
                      pageSize={pagination.pageSize}
                      pageSizeOptions={PAGE_SIZE_OPTIONS}
                      onSortingChange={() => {}}
                      onPaginationChange={onPaginationChange}
                    />
                  )}
                </>
              )}
            </Flex>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default BulkGiftingDetailsModal;
